import { ReactNode, createContext, useContext } from "react";
import { UseFormReturn } from "react-hook-form";

import {
  TCreateWeighBridge,
  TUpdateWeighBridge,
} from "@/schemas/weighbridge-schema";

interface WithAttachmentContextProps {
  form: UseFormReturn<
    TCreateWeighBridge | TUpdateWeighBridge,
    Partial<TCreateWeighBridge | TUpdateWeighBridge>
  >;

  handleDeleteProject: (index: number) => void;
  handleAddProject: () => void;
}

const WithAttachmentContext = createContext<
  WithAttachmentContextProps | undefined
>(undefined);

export const useWithAttachmentContext = (): WithAttachmentContextProps => {
  const context = useContext(WithAttachmentContext);
  if (!context) {
    throw new Error(
      "useWithAttachmentContext must be used within a WithAttachmentProvider",
    );
  }

  return context;
};

export const WithAttachmentProvider = ({
  children,
  ...props
}: WithAttachmentContextProps & { children: ReactNode }): JSX.Element => {
  return (
    <WithAttachmentContext.Provider value={props}>
      {children}
    </WithAttachmentContext.Provider>
  );
};
